import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import store from './redux/store'

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./utils/diasbleLogs"

import QueryProvider from "./lib/query-provider";

const rootElement = document.getElementById('root')
ReactDOM.render(
  <Provider store={store}>
    <QueryProvider>
      <App />
    </QueryProvider>
  </Provider>,
  rootElement
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
